import React, { useContext, useEffect, useState } from 'react';
import NavBar from '../../Components/NavBar/NavBar';
import { Grid, Paper, Button, Container, Box } from '@mui/material';
import TypographyCustom from '../../Components/Typography/TypographyCustom';
import { Alert, Checkbox, DatePicker, Form, Input, Radio, Select, TimePicker } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { LINK_NUMBER_WA, fontFamily, greenColor, primaryColor, whiteColor } from '../../Utils/Constants';
import Footer from '../../Components/Footer/Footer';
import { DataContext } from '../../Context/DataContext';
import { getAllCar } from '../../Components/api/car';
import { resolveVehicleImage, textWaCheckoutOrder } from '../../Utils/functionUtils';
import ModalTnc from '../../Components/Modal/ModalTnc';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'
import withReactContent from 'sweetalert2-react-content'

const Checkout = () => {
  const MySwal = withReactContent(Swal);
  const [form] = Form.useForm();

  const { allState } = useContext(DataContext);
  const { orderForm, setOrderForm, locale } = allState;
  const [listCar, setListCar] = useState([]);
  const [listTypeCar, setListTypeCar] = useState([]);
  const [vehicle, setVehicle] = useState(orderForm.vehicle || '');
  const [type, setType] = useState(orderForm.typeVehicle || '');
  const [image, setImage] = useState(orderForm.image || '');
  const [tnc, setTnc] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const intl = useIntl();
  const requiredRule = [{ required: true, message: intl.formatMessage({ id: 'checkoutRequired' }) }];

  const applyVehicleMeta = (value, vehicleList = listTypeCar) => {
    const selected = vehicleList.find((item) => item.name === value);
    if (!selected) return;
    setType(selected.type);
    setImage(selected.image);
  };

  useEffect(() => {
    if (listCar.length === 0) {
      getAllCar()
        .then((res) => {
          const vehicles = res.data.data || [];
          const listName = vehicles.map((item) => ({
            value: item.name,
            label: item.name,
            category: item.vehicle || item.category
          }));
          const listType = vehicles.map((item) => ({
            name: item.name,
            type: item.type,
            image: item.image,
            category: item.vehicle || item.category
          }));
          setListCar(listName);
          setListTypeCar(listType);
          const selectedVehicle = form.getFieldValue('vehicle') || orderForm.vehicle;
          if (selectedVehicle) {
            applyVehicleMeta(selectedVehicle, listType);
          }
        })
    }
  }, [listCar])

  const handleChange = (value) => {
    setVehicle(value);
    applyVehicleMeta(value);
  };

  const groupedVehicleOptions = [
    {
      label: intl.formatMessage({ id: 'listItemVehicleItem1' }),
      options: listCar
        .filter((item) => item.category === 'MOTORCYCLE')
        .map((item) => ({ value: item.value, label: item.label }))
    },
    {
      label: intl.formatMessage({ id: 'listItemVehicleItem2' }),
      options: listCar
        .filter((item) => item.category === 'CAR')
        .map((item) => ({ value: item.value, label: item.label }))
    },
    {
      label: intl.formatMessage({ id: 'listItemVehicle' }),
      options: listCar
        .filter((item) => item.category !== 'MOTORCYCLE' && item.category !== 'CAR')
        .map((item) => ({ value: item.value, label: item.label }))
    }
  ].filter((group) => group.options.length > 0);

  const handleWhatsAppOrder = async () => {
    try {
      const values = await form.validateFields();
      if (!tnc) {
        MySwal.fire({
          title: <strong>Checkout Failed</strong>,
          html: <i>{intl.formatMessage({ id: 'checkoutTermAndCondition' })}</i>,
          showConfirmButton: false,
          timer: 1500,
          icon: 'error'
        });
        return;
      }

      const statusLabel = intl.formatMessage({
        id: values.status === 'STUDENT'
          ? 'checkoutStatusStudent'
          : values.status === 'TOURIST'
            ? 'checkoutStatusTourist'
            : 'checkoutStatusEmployee'
      });

      setOrderForm({
        ...orderForm,
        vehicle: values.vehicle,
        typeVehicle: type,
        name: values.name,
        addressBali: values.addressBali,
        cityKtp: values.cityKtp,
        phoneNumber: values.phoneNumber,
        instagram: values.instagram,
        image: image,
        pickUpDate: values.pickUpDate,
        pickUpTime: values.pickUpTime,
        dropOffDate: values.dropOffDate,
        dropOffTime: values.dropOffTime,
        purpose: values.purpose,
        status: values.status
      });

      const waText = textWaCheckoutOrder(locale, {
        ...values,
        statusLabel
      });
      window.open(`${LINK_NUMBER_WA}?text=${encodeURIComponent(waText)}`, '_blank', 'noopener,noreferrer');
    } catch (error) {
      MySwal.fire({
        title: <strong>Checkout Failed</strong>,
        html: <i>{intl.formatMessage({ id: 'checkoutRequired' })}</i>,
        showConfirmButton: false,
        timer: 1500,
        icon: 'error'
      });
    }
  }

  return (
    <div>
      <NavBar />
      <Container style={{ marginBottom: "2rem" }}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            vehicle: orderForm.vehicle,
            name: orderForm.name,
            addressBali: orderForm.addressBali || orderForm.location,
            cityKtp: orderForm.cityKtp,
            phoneNumber: orderForm.phoneNumber,
            instagram: orderForm.instagram,
            pickUpDate: orderForm.pickUpDate || undefined,
            pickUpTime: orderForm.pickUpTime || undefined,
            dropOffDate: orderForm.dropOffDate || undefined,
            dropOffTime: orderForm.dropOffTime || undefined,
            purpose: orderForm.purpose,
            status: orderForm.status
          }}
        >
          <Grid container>
            <Grid item xs={12} sm={8}>
              <Box sx={{ width: { xs: "100%", md: "90%" } }}>
                <Paper style={{ padding: "20px", marginTop: "40px" }} elevation={2}>
                  <TypographyCustom
                    variant={"h5"}
                    content="checkoutForm"
                    style={{ color: primaryColor, fontWeight: "700" }}
                  />
                  <br />
                  <Form.Item style={{ fontFamily: fontFamily }} name={'name'} label={<FormattedMessage id='checkoutName' />} rules={requiredRule}>
                    <Input placeholder={intl.formatMessage({ id: 'checkoutNamePlaceholder' })} />
                  </Form.Item>
                  <Form.Item style={{ fontFamily: fontFamily }} name={'vehicle'} label={<FormattedMessage id="checkoutVehicle" />} rules={requiredRule}>
                    <Select
                      style={{
                        width: '100%',
                        textAlign: 'start'
                      }}
                      placeholder={intl.formatMessage({ id: 'checkoutVehiclePlaceholder' })}
                      onChange={handleChange}
                      options={groupedVehicleOptions}
                    />
                  </Form.Item>
                  <Form.Item style={{ fontFamily: fontFamily }} label={<FormattedMessage id="checkoutTypeVehicle" />} >
                    {
                      type ?
                        <TypographyCustom
                          variant={"body2"}
                          content={type === 'MATIC' ? "checkoutTypeMatic" : type === 'ELECTRIC' ? "checkoutTypeElectric" : "checkoutTypeManual"}
                          style={{ textAlign: 'start' }}
                        />
                        : <>-</>
                    }
                  </Form.Item>
                  <Form.Item style={{ fontFamily: fontFamily }} name={'addressBali'} label={<FormattedMessage id='checkoutAddressBali' />} rules={requiredRule}>
                    <Input placeholder={intl.formatMessage({ id: 'checkoutAddressBaliPlaceholder' })} />
                  </Form.Item>
                  <Form.Item style={{ fontFamily: fontFamily }} name={'cityKtp'} label={<FormattedMessage id='checkoutCityKtp' />} rules={requiredRule}>
                    <Input placeholder={intl.formatMessage({ id: 'checkoutCityKtpPlaceholder' })} />
                  </Form.Item>
                  <Form.Item style={{ fontFamily: fontFamily }} name={'phoneNumber'} label={<FormattedMessage id='checkoutPhoneNumber' />} rules={requiredRule}>
                    <Input placeholder={intl.formatMessage({ id: 'checkoutPhoneNumberPlaceholder' })} />
                  </Form.Item>
                  <Form.Item style={{ fontFamily: fontFamily }} name={'instagram'} label={<FormattedMessage id='checkoutInstagram' />} rules={requiredRule}>
                    <Input placeholder={intl.formatMessage({ id: 'checkoutInstagramPlaceholder' })} />
                  </Form.Item>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Form.Item style={{ fontFamily: fontFamily }} name='pickUpDate' label={<FormattedMessage id='checkoutStartRent' />} rules={requiredRule}>
                        <DatePicker
                          placeholder={intl.formatMessage({ id: 'hedaerFormPickUpPlaceHolder' })}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Grid>
                    <Grid item xs={6}>
                      <Form.Item style={{ fontFamily: fontFamily }} name='pickUpTime' label={' '} rules={requiredRule}>
                        <TimePicker
                          placeholder={intl.formatMessage({ id: 'hedaerFormPickUpTimePlaceHolder' })}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Form.Item style={{ fontFamily: fontFamily }} name='dropOffDate' label={<FormattedMessage id='checkoutEndRent' />} rules={requiredRule}>
                        <DatePicker
                          placeholder={intl.formatMessage({ id: 'headerFormDropOffPlaceHolder' })}
                          style={{ width: "100%", marginRight: "3%" }}
                        />
                      </Form.Item>
                    </Grid>
                    <Grid item xs={6}>
                      <Form.Item style={{ fontFamily: fontFamily }} name='dropOffTime' label={' '} rules={requiredRule}>
                        <TimePicker
                          placeholder={intl.formatMessage({ id: 'headerFormDropOffTimePlaceHolder' })}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Grid>
                  </Grid>
                  <Form.Item style={{ fontFamily: fontFamily }} name={'purpose'} label={<FormattedMessage id='checkoutPurpose' />} rules={requiredRule}>
                    <Input.TextArea rows={3} placeholder={intl.formatMessage({ id: 'checkoutPurposePlaceholder' })} />
                  </Form.Item>
                  <Form.Item style={{ fontFamily: fontFamily }} name={'status'} label={<FormattedMessage id='checkoutStatus' />} rules={requiredRule}>
                    <Radio.Group>
                      <Radio value={'STUDENT'}>
                        <FormattedMessage id="checkoutStatusStudent" />
                      </Radio>
                      <Radio value={'TOURIST'}>
                        <FormattedMessage id="checkoutStatusTourist" />
                      </Radio>
                      <Radio value={'EMPLOYEE'}>
                        <FormattedMessage id="checkoutStatusEmployee" />
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item>
                    <div style={{ display: "flex" }}>
                      <Checkbox name='checkTnc' value={tnc} onChange={() => setTnc(!tnc)} style={{ marginRight: '1rem' }} />
                      <TypographyCustom
                        variant={"body2"}
                        content="checkoutTermAndCondition"
                        style={{ textAlign: 'start' }}
                      />
                    </div>
                    <div
                      onClick={() => setModalOpen(true)}
                    >
                      <TypographyCustom
                        variant={"body2"}
                        content="checkoutReadTermAndCondition"
                        style={{ textAlign: 'start', color: primaryColor, fontWeight: "700" }}
                      />
                    </div>
                  </Form.Item>
                </Paper>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ width: { xs: "100%", md: "90%" } }}>
                <Paper style={{ padding: "20px", marginTop: "40px" }} elevation={2}>
                  <img
                    src={resolveVehicleImage(image)}
                    alt={vehicle || 'vehicle'}
                    style={{ width: "100%", marginTop: "-30px", objectFit: "contain" }}
                  />
                  <Alert
                    type="warning"
                    showIcon
                    message={<FormattedMessage id="checkoutWebMaintenance" />}
                    style={{ textAlign: 'start', marginBottom: '1rem', fontFamily }}
                  />
                  <Button disabled type="button" style={{ backgroundColor: '#9e9e9e', color: whiteColor, width: "100%", cursor: 'not-allowed' }}>
                    <TypographyCustom
                      content="checkoutForm"
                    />
                  </Button>
                  <div style={{ marginBlock: '0.6rem' }}>
                    <TypographyCustom
                      variant={"caption"}
                      content="or"
                    />
                  </div>
                  <Button type="button" onClick={handleWhatsAppOrder} style={{ backgroundColor: greenColor, color: whiteColor, width: "100%" }}>
                    <FormattedMessage id="itemOrderVehicle" /> Via WA
                  </Button>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Form>
        <ModalTnc
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />
      </Container>
      <Footer />
    </div>
  );
};

export default Checkout;
